const carouselize = options => {
  const { itemContainer, swipeContainer, prevButton, nextButton, wrapAround, numberFocusedItems } =
    options

  itemContainer.classList.toggle('item-container', true)
  if (prevButton) prevButton.classList.toggle('carousel-button', true)
  if (prevButton) prevButton.classList.toggle('prev', true)
  if (nextButton) nextButton.classList.toggle('carousel-button', true)
  if (nextButton) nextButton.classList.toggle('next', true)
  let isDown = false
  let xDown
  let yDown
  let turn = 0
  const noFocused = numberFocusedItems || 1

  // lower this number for more sensitive swipe detection
  // 0 to disable
  const dragThreshold = 5

  const turnCarousel = delta => {
    const count = itemContainer.childElementCount
    const classes = itemContainer.classList
    classes.toggle(`turn-${turn}`, false)
    turn += delta
    if (!wrapAround) {
      turn = Math.max(0, turn)
      turn = Math.min(turn, count - noFocused)
    }
    turn = (turn + count - noFocused + 1) % (count - noFocused + 1)
    classes.toggle(`turn-${turn}`, true)
    if (prevButton) prevButton.classList.toggle('hide', !wrapAround && turn === 0)
    if (nextButton) nextButton.classList.toggle('hide', !wrapAround && turn === count - noFocused)
  }

  if (prevButton)
    prevButton.addEventListener('click', () => {
      turnCarousel(-1)
    })
  if (nextButton)
    nextButton.addEventListener('click', () => {
      turnCarousel(1)
    })

  turnCarousel(0)

  const eventDown = e => {
    isDown = true

    if (e.touches) {
      xDown = e.touches[0].clientX
      yDown = e.touches[0].clientY
    } else {
      xDown = e.x
      yDown = e.y
    }
    // e.preventDefault()
    return true
  }

  const eventMove = e => {
    // e.preventDefault()
    if (!isDown) return true
    let dx = 0
    let dy = 0
    if (e.touches) {
      dx = xDown - e.touches[0].clientX
      dy = yDown - e.touches[0].clientY
    } else {
      dx = xDown - e.x
      dy = yDown - e.y
    }

    const d = Math.sqrt(dx * dx + dy * dy)

    if (dragThreshold <= 0 || d < dragThreshold) {
      return true
    }

    isDown = false // has swiped

    if (dy * dy > dx * dx) return true // is vertical swipe, abort

    if (dx > 0) turnCarousel(1) // turn right
    if (dx < 0) turnCarousel(-1) // turn left
    return true
  }

  const eventUp = () => {
    isDown = false

    return true
  }

  swipeContainer.onmousedown = e => eventDown(e)
  swipeContainer.onmousemove = e => eventMove(e)
  swipeContainer.onmouseup = e => eventUp(e)
  swipeContainer.addEventListener('touchstart', eventDown, false)
  swipeContainer.addEventListener('touchmove', eventMove, false)
  swipeContainer.addEventListener('touchup', eventUp, false)
  swipeContainer.addEventListener('touchcancel', eventUp, false)
}

/*

  // EXAMPLE

  import carouselize from '../components/Utilities/Carouselize/Carouselize'

  .swipe-container { border: solid 6px #070; }
  .item-container {
    border: solid 6px #000;
    width: 400px;
    height: 100px;
    overflow: hidden;
  }
  .box { min-width: 200px; height: 100%; }
  .box:nth-child(1) { background-color: red;  }
  .box:nth-child(2) { background-color: orange; }
  .box:nth-child(3) { background-color: yellow; }
  .box:nth-child(4) { background-color: green; }
  .box:nth-child(5) { background-color: blue; }

  <body>
    <div class="swipe-container">
      <div class="item-container">
        <div class="box"></div>
        <div class="box"></div>
        <div class="box"></div>
        <div class="box"></div>
        <div class="box"></div>
      </div>
      <button class="prev-button">Previous</button>
      <button class="next-button">Next</button>
    </div>
  </body>

  componentDidMount() {
    const options = {
      swipeContainer: document.querySelector(".swipe-container"),
      itemContainer: document.querySelector(".item-container"),
      prevButton: document.querySelector(".prev-button"),
      nextButton: document.querySelector(".next-button"),
      wrapAround: false, // false will stop turning when reaching first or last item
      numberFocusedItems: 2, // how many items to show at once
    };
    carouselize(options);
  };

*/

export default carouselize
